export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/double_diamond-021807531db62ea39d8b9fb8776c14b7.svg";